import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Award, Shield, Clock, Zap, Lock } from 'lucide-react';

const APropos = () => {
  const values = [
    { icon: Award, title: 'Excellence', desc: 'Standard de qualité élevé dans chaque prestation' },
    { icon: Target, title: 'Précision', desc: 'Attention aux détails et coordination parfaite' },
    { icon: Lock, title: 'Confidentialité', desc: 'Protection totale de vos informations' },
    { icon: Shield, title: 'Exclusivité', desc: 'Nombre limité de clients pour un service premium' },
    { icon: Zap, title: 'Réactivité Absolue', desc: 'Réponse immédiate à tous vos besoins' },
    { icon: Clock, title: 'Disponibilité 24/7', desc: 'Assistance continue, jour et nuit' }
  ];

  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Hero Section */}
      <section style={{
        padding: '180px 0 100px',
        background: 'var(--bg-page)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div className="caption" style={{
            color: 'var(--brand-primary)',
            marginBottom: '20px'
          }}>
            À Propos de L'Agence
          </div>
          <h1 className="heading-1" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px',
            maxWidth: '900px'
          }}>
            Excellence, exclusivité et précision logistique
          </h1>
        </div>
      </section>

      {/* Our Story */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '60px',
            alignItems: 'center'
          }}>
            <div>
              <h2 className="heading-2" style={{
                color: 'var(--brand-primary)',
                marginBottom: '30px'
              }}>
                Notre histoire
              </h2>
            </div>
            <div>
              <p className="body-medium" style={{
                color: 'var(--text-secondary)',
                marginBottom: '20px'
              }}>
                L'Agence est née d'un constat simple : les entreprises perdent un temps considérable à organiser des voyages, gérer des imprévus, coordonner des déplacements ou planifier des événements, alors que ce ne sont pas leurs métiers.
              </p>
              <p className="body-medium" style={{
                color: 'var(--text-secondary)',
                marginBottom: '20px'
              }}>
                Notre mission est donc de leur permettre de se concentrer pleinement sur leur cœur d'activité, pendant que nous prenons en charge toute la logistique voyage et événementielle.
              </p>
              <p className="body-medium" style={{
                color: 'var(--text-secondary)'
              }}>
                Nous gérons ce qu'elles ne devraient pas gérer elles-mêmes : l'organisation, la coordination, le suivi, la fluidité.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section style={{
        padding: '100px 0',
        background: 'var(--secondary-olive)',
        borderTop: '1px solid var(--border-medium)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="heading-2" style={{
              color: 'var(--brand-primary)',
              marginBottom: '30px'
            }}>
              Notre approche
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)'
            }}>
              Nous collaborons en synergie totale avec vos équipes internes — direction, RH, logistique, finance — afin d'intégrer nos services à vos processus tout en les simplifiant.
            </p>
          </div>
        </div>
      </section>

      {/* Exclusive Service */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <h2 className="heading-2" style={{
              color: 'var(--brand-primary)',
              marginBottom: '40px',
              textAlign: 'center'
            }}>
              Un service exclusif
            </h2>
            <div style={{
              background: 'var(--bg-card)',
              padding: '60px 40px',
              border: '2px solid var(--brand-primary)'
            }}>
              <p className="body-large" style={{
                color: 'var(--text-secondary)',
                marginBottom: '20px',
                textAlign: 'center'
              }}>
                L'Agence fonctionne sur un modèle volontairement limité.
              </p>
              <p className="body-medium" style={{
                color: 'var(--text-secondary)',
                marginBottom: '30px',
                textAlign: 'center'
              }}>
                Nous n'acceptons qu'un nombre restreint de clients afin de garantir :
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                {[
                  'une attention véritablement personnelle',
                  'une qualité constante',
                  'aucune standardisation',
                  'un suivi 24/7',
                  'une connaissance intime des besoins et préférences de chaque entreprise',
                  'une réactivité immédiate'
                ].map((item, index) => (
                  <li key={index} style={{
                    marginBottom: '15px',
                    paddingLeft: '30px',
                    position: 'relative',
                    color: 'var(--text-secondary)',
                    fontSize: '1.1rem'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: 'var(--brand-primary)',
                      fontSize: '1.5rem'
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Nos valeurs
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px'
          }}>
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} style={{
                  background: 'var(--bg-card)',
                  padding: '40px',
                  border: '1px solid var(--border-medium)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease, background-color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.backgroundColor = 'var(--secondary-olive)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = 'var(--bg-card)';
                }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%'
                  }}>
                    <Icon size={32} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-4" style={{
                    color: 'var(--brand-primary)',
                    marginBottom: '15px',
                    fontSize: '1.1rem'
                  }}>
                    {value.title}
                  </h3>
                  <p className="body-small" style={{
                    color: 'var(--text-secondary)'
                  }}>
                    {value.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px'
          }}>
            Rejoignez nos clients privilégiés
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px'
          }}>
            Découvrez comment L'Agence peut transformer votre gestion des voyages d'affaires et événements corporate.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact" className="btn-primary">
              Nous contacter <ArrowRight size={20} />
            </Link>
            <a href="tel:+243841223949" className="btn-secondary">
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default APropos;